<template>
  <v-expand-transition>
    <v-card flat class="mt-4">
      <v-list one-line class="skills">
        <v-list-item-group v-model="judgementId" :multiple="false">
          <v-radio-group v-model="radioLevel" hide-details>
            <template v-for="i in 4">
              <v-list-item
                v-if="element && element.subElement"
                :class="`skill${i} ${i==radioLevel ? 'active' : ''} ${radioLevel> 0 && !achievementLevel(i, element) ? 'notactive' : ''} ${achievementLevel(i, element) && 'v-list-item--highlight'}` "
                :key="i"
                :disabled="!radiobuttons || i <= element.subElement.maxInstructorSkillEstimatedLevel || isSubElementApproved(element)"
                @click="knowledgeClick(i, element)"
              >
                <div v-if="i==1" class="content">
                  <v-list-item-avatar tile size="30">
                    <v-icon>$sl-ebook-lvl1</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-content>{{element.subElement.level1Text}}</v-list-item-content>
                  </v-list-item-content>
                </div>
                <div v-else-if="i==2" class="content">
                  <v-list-item-avatar tile size="30">
                    <v-icon>$sl-ebook-lvl2</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-content>{{element.subElement.level2Text}}</v-list-item-content>
                  </v-list-item-content>
                </div>
                <div v-else-if="i==3" class="content">
                  <v-list-item-avatar tile size="30">
                    <v-icon>$sl-ebook-lvl3</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-content>{{element.subElement.level3Text}}</v-list-item-content>
                  </v-list-item-content>
                </div>
                <div v-else class="content">
                  <v-list-item-avatar tile size="30">
                    <v-icon>$sl-ebook-lvl4</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-content>{{element.subElement.level4Text}}</v-list-item-content>
                  </v-list-item-content>
                </div>

                <v-list-item-action>
                  <v-radio :value="i" :disabled="!radiobuttons" v-if="i > element.subElement.maxInstructorSkillEstimatedLevel"></v-radio>
                  <v-icon v-else>$sl-completed</v-icon>
                </v-list-item-action>
                <!-- <v-list-item-avatar v-if="radiobuttons">
                <div class="dvRadio">
                  <input type="radio" v-model="radioLevel" :value="i" />
                  <div class="check">
                    <div class="inside"></div>
                  </div>
                </div>
                </v-list-item-avatar>-->
              </v-list-item>
            </template>
          </v-radio-group>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-expand-transition>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

// @group Common
// KnowledgeBoxes component
export default {
  name: 'KnowledgeBoxes',

  props: {
    // Books element props
    elem: Object,
    // has radio buttons
    radiobuttons: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    // is instructor
    isInstructor: {
       // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    // is Apprentice
    isApprentice: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    }
  },

  data: () => ({
    judgementId: -1,
    skills: [],
    radioLevel: -1,
    element: {
      subElement: {level1Text: '', level2Text: '', level3Text: '', level4Text: ''}
    },
    icon: [false, false, false, false]
  }),

  created() {
    this.init()
  },

  watch: {
    elem: {
      handler() {
        this.init()
      },
      deep: true
    },
    radiobuttons(val) {
      this.init()
    }
  },

  methods: {
    /**
     * @vuese
     * Used to set radio level based on instructor Skill Estimated Level and based on is instructor or apprentice
     */
    init() {      
      //if (this.isInstructor && this.radiobuttons === true && this.elem) {
        if (this.isInstructor && this.elem) {        
        this.icon[this.elem.instructorSkillEstimatedLevel] = true
        if (this.elem.instructorSkillEstimatedLevel) {
          this.radioLevel = this.elem.instructorSkillEstimatedLevel          
        } else {
          this.elem.instructorSkillEstimatedLevel = this.elem.apprenticeshipSkillEstimatedLevel
          this.radioLevel = this.elem.apprenticeshipSkillEstimatedLevel          
           // Fire special emit Instructor Skill Estimated Level Without Clicking
          // @arg The argument is a integer representing apprenticeship Skill Estimated Level
          this.$emit('emitInstructorSkillEstimatedLevelWithoutClicking', this.elem.apprenticeshipSkillEstimatedLevel)
        }
      } else {        
        if (
          this.elem &&
          this.elem.apprenticeshipSkillEstimatedLevel &&
          this.elem.apprenticeshipSkillEstimatedLevel > 0
        ) {
          this.icon[this.elem.apprenticeshipSkillEstimatedLevel] = true
          this.radioLevel = this.elem.apprenticeshipSkillEstimatedLevel
        } else {
          this.radioLevel = -1
        }
      }

      if (this.isApprentice) {
        if (this.elem && this.elem.maxInstructorSkillEstimatedLevel && this.elem.maxInstructorSkillEstimatedLevel > 0) {
          this.icon[this.elem.maxInstructorSkillEstimatedLevel] = true
          this.radioLevel = this.elem.maxInstructorSkillEstimatedLevel
        } else if (
          this.isApprentice &&
          this.elem &&
          this.elem.apprenticeshipSkillEstimatedLevel &&
          this.elem.apprenticeshipSkillEstimatedLevel > 0
        ) {
          this.icon[this.elem.apprenticeshipSkillEstimatedLevel] = true
          this.radioLevel = this.elem.apprenticeshipSkillEstimatedLevel
        } else {
          this.radioLevel = -1
        }
      }

      this.element = this.elem
    },
    /**
     * @vuese
     * Used to emit Skill Estimated Level
     * @arg The argument is an integer representing  Skill Estimated Level
     */
    knowledgeClick(id, element = {}) {
      if (!this.radiobuttons || this.isSubElementApproved(element)) return
      let i
      this.radioLevel = id
      for (i = 1; i < 5; i++) {
        if (id && Number(id) === i) {
          this.icon[i] = true
        } else {
          this.icon[i] = false
        }
      }
      // Fire knowledgeClick
      // @arg The argument is a integer representing  Skill Estimated Level
      this.$emit('knowledgeClick', id)
    },

    achievementLevel(index, element = {}) {
      return index === element.subElement?.requiredLevel
    },

    isSubElementApproved(element = {}) {
      return element.subElement.isApproved
    }
  }
}
</script>

<style scoped lang="scss">
  .v-list-item {
    &--highlight {
      &:not(.v-list-item--disabled) {
        border: 2px solid #000;
        background-color: #dcecbc !important;
      }
    }
  }
</style>
